module.exports = __webpack_public_path__ + "img/trunk_1x1_z18.aad09f03.svg";